window.onerror = function(message, source, lineno, colno, error) {
  document.body.innerHTML = `
    <div style="padding: 20px; background-color: #ffebee; color: #c62828; font-family: sans-serif; height: 100vh; overflow-y: auto;">
      <h2 style="font-weight: 900; margin-bottom: 10px;">🚨 CRASHED BEFORE STARTING</h2>
      <p style="font-size: 14px; font-weight: bold;">Basant Bhai, asli Error yahan hai:</p>
      <p style="margin-top: 10px;"><strong>Error:</strong> ${message}</p>
      <p style="font-size: 11px; background: black; color: lime; padding: 15px; border-radius: 8px; margin-top: 15px; white-space: pre-wrap; word-wrap: break-word;">
        ${error && error.stack ? error.stack : source + ' (Line: ' + lineno + ')'}
      </p>
    </div>
  `;
  return true;
};
